import fetch ,{postFrom, getBlob} from "../utils/fetch";

export function updateEpsAccount(params) {
  return fetch({
    method:'POST',
    url:'/surrender/updateEpsAccount',
    data:params
  })
}

export function updateNoCancelBills(params) {
  return fetch({
    method:'POST',
    url:'/surrender/updateNoCancelBills',
    data:params
  })
}
export function contractText(params) {
  return fetch({
    method:'GET',
    url:'/surrender/preview/contractText',
    params
  })
}
export function list(params) {
  return fetch({
    method:'POST',
    url:'/enterprisecontract/list',
    data:params
  })
}

export function selectCondition() {
  return fetch({
    method:'GET',
    url:'/enterprisecontract/selectCondition',
  })
}
export function getStatusNum() {
  return fetch({
    method:'GET',
    url:'/enterprisecontract/getStatusNum',
  })
}

export function getSignInviteInfo(params) {
  return fetch({
    method:'GET',
    url:'/signinvite/getSignInviteInfo',
    params
  })
}
export function saveSignInviteInfo(params) {
  return fetch({
    method:'POST',
    url:'/signinvite/saveSignInviteInfo',
    data:params
  })
}
export function validSignInvite(params) {
  return fetch({
    method:'GET',
    url:'/signinvite/validSignInvite',
    params
  })
}
export function toUnRentApply(params) {
  return fetch({
    method:'GET',
    url:'/surrender/toUnRentApply',
    params
  })
}

export function queryEpsRentRoom(params) {
  return fetch({
    method:'GET',
    url:'/surrender/queryEpsRentRoom',
    params
  })
}
export function submitUnRentApply(params) {
  return fetch({
    method:'POST',
    url:'/surrender/submitUnRentApply',
    data:params
  })
}

export function getPersonalSurrenderInitInfo(params) {
  return fetch({
    method:'GET',
    url:'/surrender/getPersonalSurrenderInitInfo',
    params
  })
}


export function getPersonalSurrenderMeterDeliveryInitInfo(params) {
  return fetch({
    method:'GET',
    url:'/surrender/getPersonalSurrenderMeterDeliveryInitInfo',
    params
  })
}


export function getSurrenderDecorationGoodsDeliveryInitInfo(params) {
  return fetch({
    method:'GET',
    url:'/surrender/getSurrenderDecorationGoodsDeliveryInitInfo',
    params
  })
}

export function getSurrenderGoodsDeliveryInitInfo(params) {
  return fetch({
    method:'GET',
    url:'/surrender/getSurrenderGoodsDeliveryInitInfo',
    params
  })
}

export function getPersonDeliverys(params) {
  return fetch({
    method:'GET',
    url:'/surrender/getPersonDeliverys',
    params
  })
}

export function validChangeRentContract(params) {
  return fetch({
    method:'POST',
    url:'/surrender/validChangeRentContract',
    params
  })
}
export function closeContract(params) {
  return fetch({
    method:'POST',
    url:'/contract/closeContract',
    params
  })
}

export function invalidContract(params) {
  return fetch({
    method:'POST',
    url:'/contract/invalidContract',
    params
  })
}
export function getParentDeliveryState(params) {
  return fetch({
    method:'GET',
    url:'/enterprisecontract/getParentDeliveryState',
    params
  })
}

export function findDeliveryInfo(params) {
  return fetch({
    method:'GET',
    url:'/sign/delivery/findDeliveryInfo',
    params
  })
}

export function deliverysave(params) {
  return fetch({
    method:'POST',
    url:'/sign/delivery/save',
    data:params
  })
}

export function deliverysaveV2(params) {
  return fetch({
    method: 'POST',
    url: '/sign/delivery/save/v2',
    data: params
  })
}

export function getEnterpriseSurrenderInitInfo(params) {
  return fetch({
    method:'GET',
    url:'/surrender/getEnterpriseSurrenderInitInfo',
    params
  })
}
export function getEnterpriseSurrenderMeterDeliveryInitInfo(params) {
  return fetch({
    method:'GET',
    url:'/surrender/getEnterpriseSurrenderMeterDeliveryInitInfo',
    params
  })
}

export function getEnterpriseDeliverys(params) {
  return fetch({
    method:'GET',
    url:'/surrender/getEnterpriseDeliverys',
    params
  })
}
export function modifyCostDetail(params) {
  return fetch({
    method:'POST',
    url:'/surrender/modifyCostDetail',
    data:params
  })
}

export function surrendersubmit(params) {
  return fetch({
    method:'POST',
    url:'/surrender/submit',
    data:params
  })
}

export function surrenderdeliverysave(params) {
  return fetch({
    method:'POST',
    url:'/surrender/delivery/save',
    data:params
  })
}
export function findCustomerQualification(params) {
  return fetch({
    method:'GET',
    url:'/enterprisecontract/findCustomerQualification',
    params
  })
}
export function calculatePrice(params) {
  return fetch({
    method:'POST',
    url:'/enterprisecontract/epsContract/calculatePrice',
    data:params
  })
}

export function surrenderCalculatePrice(params) {
  return fetch({
    method:'GET',
    url:'/surrender/surrenderCalculatePrice',
    params
  })
}
export function enterprisecontractroomCanRent(params) {
  // return fetch({
  //   method:'GET',
  //   url:'/enterprisecontract/roomCanRent',
  //   params
  // })
  return postFrom('/enterprisecontract/roomCanRent',params)
}


export function epsbaseupdate(params) {
  return fetch({
    method:'POST',
    url:'/surrender/eps/base/update',
    data:params
  })
}

export function epssubmit(params) {
  return fetch({
    method:'POST',
    url:'/surrender/eps/submit',
    data:params
  })
}

export function renewstockinfo(params) {
  return fetch({
    method:'GET',
    url:'/enterprisecontract/renew/stock/info',
    params
  })
}

export function getSignSubject(params) {
  return fetch({
    method:'GET',
    url:'/enterprisecontract/getSignSubject',
    params
  })
}
export function getSparePart(params) {
  return fetch({
    method:'GET',
    url:'/enterprisecontract/getSparePart',
    params
  })
}
export function updateSparePart(params) {
  return fetch({
    method:'POST',
    url:'/enterprisecontract/updateSparePart',
    data:params
  })
}

export function findEntryDeliveryInfo(params) {
  return fetch({
    method:'GET',
    url:'/sign/delivery/findEntryDeliveryInfo',
    params
  })
}
export function deliverygoods(params) {
  return fetch({
    method:'GET',
    url:'/sign/delivery/goods',
    params
  })
}

export function checkRentApply(params) {
  return fetch({
    method:'GET',
    url:'/surrender/checkRentApply',
    params
  })
}
export function closeUnRentApply(params) {
  return fetch({
    method:'POST',
    url:'/surrender/closeUnRentApply',
    params
  })
}
export function updateUnRentApply(params) {
  return fetch({
    method:'POST',
    url:'/surrender/updateUnRentApply',
    data:params
  })
}
export function confirmContractForEps(params) {
  return fetch({
    method:'GET',
    url:'/enterprisecontract/confirmContractForEps',
    params
  })
}

export function choosePayment(params) {
  return fetch({
    method:'POST',
    url:'/enterprisecontract/choosePayment',
    data:params
  })
}

export function calSurrenderMeterDeliveryAmount(params) {
  return fetch({
    method:'GET',
    url:'/surrender/calSurrenderMeterDeliveryAmount',
    params
  })
}

export function surrenderCalculatePriceDetail(params) {
  return fetch({
    method:'GET',
    url:'/surrender/surrenderCalculatePriceDetail',
    params
  })
}

export function epsContractcreate(params) {
  return fetch({
    method:'POST',
    url:'/enterprisecontract/epsContract/create',
    data:params
  })
}


export function checkBeforeSurrender(params) {
  return fetch({
    method:'GET',
    url:'/surrender/checkBeforeSurrender',
    params
  })
}
export function roomCanRenew(params) {
  return fetch({
    method:'GET',
    url:'/enterprisecontract/roomCanRenew',
    params
  })
}


export function personalsubmit(params) {
  return fetch({
    method:'POST',
    url:'/surrender/personal/submit',
    data:params
  })
}


export function submitForApp(params) {
  return fetch({
    method:'POST',
    url:'/surrender/personal/submitForApp',
    data:params
  })
}

// 导出合同列表
export function exportContractList(data) {
  return getBlob({
    method:'POST',
    url:'enterprisecontract/exportContractList',
    data
  })
}

// 合同列表数量查询
export function checkContractCount(data) {
  return fetch({
    method:'POST',
    url:'enterprisecontract/findExportContractCount',
    data
  })
}


//解约申请或者修改 获取未核销账单
export function getNoCancelBills(params) {
  return fetch({
    method:'GET',
    url:'/surrender/getNoCancelBills',
    params
  })
}


//解约详情 获取未核销账单
export function getNoCancelBillsInfo(params) {
  return fetch({
    method:'GET',
    url:'/surrender/getNoCancelBillsInfo',
    params
  })
}

export function saveNoCancelBills(params) {
  return fetch({
    method:'POST',
    url:'/surrender/saveNoCancelBills',
    data:params
  })
}

export function getSurrenderBalancePaymentsInfo(params) {
  return fetch({
    method:'GET',
    url:'/surrender/getSurrenderBalancePaymentsInfo',
    params
  })
}

export function surrenderBalancePayment(params) {
  return fetch({
    method:'GET',
    url:'/surrender/surrenderBalancePayment',
    params
  })
}
export function isEnteredCertificate(params) {
  return fetch({
    method:'POST',
    url:'/surrender/isEnteredCertificate',
    params
  })
}


// 查询即将退租列表
export function getContractEndList(params) {
  return fetch({
    method: 'GET',
    url: 'contract/getContractEndList',
    params
  })
}


// 查询银行列表
export function getBankInfo(params) {
  return fetch({
    method: 'GET',
    url: 'financebaseinfo/getbankInfo',
    params
  })
}

//获取原路退明细
export function getRefunDetailsByBusid(params) {
  return fetch({
    method: 'GET',
    url: 'paymentbill/getRefundDetail',
    params
  })
}


export function uploadVoucher(params) {
  return fetch({
    method:'POST',
    url:'/surrender/uploadVoucher',
    data:params
  })
}


export function getVouchers(params) {
  return fetch({
    method:'GET',
    url:'/surrender/getVouchers',
    params
  })
}

export function delVouchers(params) {
  return fetch({
    method:'POST',
    url:'/surrender/delVouchers',
    params:params
  })
}

export function getChannelTypes() {
  return fetch({
    method: 'GET',
    url: 'sign/delivery/channelTypes'
  })
}

// 作废合同

export function contractBtn(params) {
  return fetch({
    method:'POST',
    url:'/cancel/contract/btn',
    params:params
  })
}

export function costDetail(params) {
  return fetch({
    method:'POST',
    url:'/cancel/modify/costDetail',
    data:params
  })
}


export function contractVoid(params) {
  return fetch({
    method:'POST',
    url:'/cancel/contract/confirm',
    params:params
  })
}

export function getBankNoList() {
  return fetch({
    method: 'GET',
    url: '/financebaseinfo/getBankNoList'
  })
}


// 获取是否是理房通项目
export function getReceiptType(params) {
  return fetch({
    method: 'GET',
    url: '/surrender/getReceiptType',
    params
  })
}

// 结算详情
export function surrenderBalanceInfoLFT(params) {
  return fetch({
    method:'POST',
    url:'/surrender/surrenderBalanceInfoLFT',
    data:params
  })
}
// 重试
export function lftSurrenderBalanceRenewOperate(params) {
  return fetch({
    method:'POST',
    url:'/surrender/lftSurrenderBalanceRenewOperate',
    data:params
  })
}
// /surrender/threeFactorVerify
// 三要素
export function threeFactorVerify(params) {
  return fetch({
      method: 'POST',
      url: '/surrender/threeFactorVerify',
      data:params
  })
}